<template>
  <easy-page-template
      title="実装に関して、何を行いますか？"
      subtitle="実装に関して行うことを、以下の中から選んでください。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconSystemImplementationData"
          title="データ実装を管理する"
          to="/edit/list/dataImplementation"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconSystemImplementationService"
          title="サービス実装を管理する"
          to="/edit/list/serviceImplementation"
          block>
      </easy-nav>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import iconSystemImplementationData from "./assets/icon_system_implementation_data.svg";
import iconSystemImplementationService from "./assets/icon_system_implementation_service.svg";
import imageTradeContract from "./assets/image_trade_contract.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";

export default {
  name: "Implementation",
  components: {EasyNav, EasyPageTemplate},
  data() {
    return {
      iconSystemImplementationData,
      iconSystemImplementationService,
      imageTradeContract
    }
  }
}
</script>

<style scoped>

</style>
